import React from "react";
import * as RB from "react-bootstrap";

function EmergencyContact({ formData, handleInputChange, setFormData,emergencyContactError1,emergencyContactError2 }) {
  return (
    <>
      <h6 className="mt-2">Emergency Contact</h6>
      <hr className="hr-lg mt-1" />
      <RB.Row>
        <RB.Col md={12}>
          <RB.Row>
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Emergency Contact No. (1)"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Enter Emergency Contact No. (1)"
                    name="emergency_contact_1"
                    value={formData.emergency_contact_1}
                    onChange={handleInputChange}
                    maxLength={10}
                    required
                  />
                  {emergencyContactError1 && (
                    <span className="text-danger">
                      Please provide a valid 10-digit emergency contact number.
                    </span>
                  )}
                </RB.FloatingLabel>
              </div>
            </RB.Col>
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Emergency Contact No. (2)"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Enter Emergency Contact No. (2)"
                    name="emergency_contact_2"
                    value={formData.emergency_contact_2}
                    onChange={handleInputChange}
                    maxLength={10}
                  />
                  {emergencyContactError2 && (
                    <span className="text-danger">
                      Please provide a valid 10-digit emergency contact number.
                    </span>
                  )}
                </RB.FloatingLabel>
              </div>
            </RB.Col>
          </RB.Row>
        </RB.Col>
      </RB.Row>

      <RB.Row>
        <RB.Col md={12}>
          <RB.Row>
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel label="Name" className="floating-label-fancy">
                  <RB.Form.Control
                    type="text"
                    placeholder="Enter Name"
                    name="emergency_contact_name"
                    value={formData.emergency_contact_name}
                    onChange={handleInputChange}
                    required
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel label="Name" className="floating-label-fancy">
                  <RB.Form.Control
                    type="text"
                    placeholder="Enter Name"
                    name="eme_conteact_name2"
                    value={formData.eme_conteact_name2}
                    onChange={handleInputChange}
                    required
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
          </RB.Row>
        </RB.Col>
      </RB.Row>

      <RB.Row>
        <RB.Col md={12}>
          <RB.Row>
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Name of Relationship"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Enter Relationship"
                    name="emergency_contact_relationship"
                    value={formData.emergency_contact_relationship}
                    onChange={handleInputChange}
                    required
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
            <RB.Col md={6}>
              <div className="mb-3">
                <RB.FloatingLabel
                  label="Name of Relationship"
                  className="floating-label-fancy"
                >
                  <RB.Form.Control
                    type="text"
                    placeholder="Enter Relationship"
                    name="eme_conteact_relation2"
                    value={formData.eme_conteact_relation2}
                    onChange={handleInputChange}
                    required
                  />
                </RB.FloatingLabel>
              </div>
            </RB.Col>
          </RB.Row>
        </RB.Col>
      </RB.Row>

      <RB.Row>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel label="Address" className="floating-label-fancy">
              <RB.Form.Control
                as="textarea"
                placeholder="Enter Address"
                style={{ height: "90px" }}
                name="emergency_contact_address"
                value={formData.emergency_contact_address}
                onChange={handleInputChange}
                required
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel label="Address" className="floating-label-fancy">
              <RB.Form.Control
                as="textarea"
                placeholder="Enter Address"
                style={{ height: "90px" }}
                name="eme_conteact_add2"
                value={formData.eme_conteact_add2}
                onChange={handleInputChange}
                required
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>
      </RB.Row>
    </>
  );
}

export default EmergencyContact;
